import { AxisItem } from '@/design-system/components/charts/axis/useAxis.hook';
import { BarChart } from '@/design-system/components/charts/barChart/BarChart';
import { View, SxProp } from 'dripsy';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactNative from 'react-native';

interface MyEarningsBarChartProps {
  data: Array<AxisItem>;
  height?: number;
}

export const MyEarningsBarChart: React.FC<MyEarningsBarChartProps> = ({ data, height }) => {
  const { t } = useTranslation();
  const ref = useRef<ReactNative.View>(null);

  const MARGIN = {
    top: 0,
    right: 0,
    bottom: 28,
    left: 50
  };

  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0
  });

  useEffect(() => {
    if (ref.current) {
      ref.current.measure((x, y, width, height) => {
        setDimensions({ width: width, height: height });
      });
    }
  }, [ref]);

  const onLayout = () => {
    if (ref.current) {
      ref.current.measure((x, y, width, height) => {
        setDimensions({ width: width, height: height });
      });
    }
  };

  return (
    <View ref={ref} sx={styles.container} onLayout={onLayout}>
      <BarChart
        data={data}
        width={dimensions?.width}
        height={height || 300}
        margin={MARGIN}
        xTitle={t('earn-invest::glossary.cumulative-earnings')}
        yTitle={t('earn-invest::glossary.usd-equivalent')}
      />
    </View>
  );
};

enum StylesName {
  container = 'container'
}

const styles: Record<StylesName, SxProp> = {
  container: {
    flex: 1
  }
};
